import styled from "@emotion/styled";
import {
    dialogClasses,
    Dialog as MuiDialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    Typography,
} from "@mui/material";

export const Dialog = styled(MuiDialog)({
    [`& .${dialogClasses.paper}`]: {
        color: "#000000",
        minWidth: 543,
        borderRadius: 10,
    },
});

export const DialogTitle = styled(MuiDialogTitle)({
    color: "#000000",
    fontSize: 20,
    fontWeight: 700,
});

export const DialogContent = styled(MuiDialogContent)({
    paddingTop: 0,
});

export const DialogContentText = styled(Typography)({
    fontSize: 15,
    fontWeight: 400,
});